import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../components/AppIcon';

const formatDateForInput = (date) => {
  if (!date) return '';
  const dt = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(dt.getTime())) return '';
  return dt.toISOString().split('T')[0];
};

const AddAttendanceEntryModal = ({
  open,
  users,
  presetUserId,
  presetDate,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation();
  const [employeeUserId, setEmployeeUserId] = useState('');
  const [date, setDate] = useState('');
  const [inTime, setInTime] = useState('');
  const [outTime, setOutTime] = useState('');
  const [remarks, setRemarks] = useState('');

  useEffect(() => {
    if (!open) return;
    setEmployeeUserId(presetUserId || '');
    setDate(presetDate ? formatDateForInput(presetDate) : '');
    setInTime('');
    setOutTime('');
    setRemarks('');
  }, [open, presetUserId, presetDate]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-card border border-border rounded-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-semibold text-foreground">{t('Add Attendance Entry')}</h3>
          <button
            type="button"
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-colors"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSave?.({ employeeUserId, date, inTime, outTime, remarks });
          }}
          className="space-y-6"
        >
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              {t('Employee')} <span className="text-red-500">*</span>
            </label>
            <select
              value={employeeUserId}
              onChange={(e) => setEmployeeUserId(e?.target?.value)}
              required
              className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            >
              <option value="">{t('Select Employee')}</option>
              {(users || []).map((u) => (
                <option key={u?.id} value={u?.id}>
                  {u?.fullName || u?.userName || u?.email || u?.id}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              {t('Date')} <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e?.target?.value)}
              required
              className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                {t('In Time')} <span className="text-red-500">*</span>
              </label>
              <input
                type="time"
                value={inTime}
                onChange={(e) => setInTime(e?.target?.value)}
                required
                className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                {t('Out Time')} <span className="text-red-500">*</span>
              </label>
              <input
                type="time"
                value={outTime}
                onChange={(e) => setOutTime(e?.target?.value)}
                required
                className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">{t('Remarks')}</label>
            <textarea
              value={remarks}
              onChange={(e) => setRemarks(e?.target?.value)}
              placeholder={t('Enter any remarks or notes...')}
              className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
              rows={3}
            />
          </div>

          <div className="flex justify-end gap-3 pt-6 border-t border-border">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm bg-muted hover:bg-muted/80 text-foreground rounded-lg transition-colors"
            >
              {t('Cancel')}
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
            >
              {t('Save Entry')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAttendanceEntryModal;
